import Vue from 'vue';
import { AutoTextResizer } from './components/AutoTextResizer';

// The following imports modify `Vue` directly, we shouldn't be doing it this
// way.  Instead we should be importing them as needed locally or globally how
// `AutoTextResizer` is being inserted.
import './directives/HashtagHighlighter';
import './directives/MarqueeWrapper';
import './filters/dateFilters';

Vue.component('auto-text-resizer', AutoTextResizer);

export { default as Vue } from 'vue';
